// ***************
// Auth.jsx
// autor: W de Paula / MVinfo
// data: 03/05/24 | 19:07h
// ***************

import {createContext } from "react";

const AuthContext = createContext({});

function AuthProvider(props){

return(
    <AuthContext.Provider value={{}}>
        {props.children}    
    </AuthContext.Provider>
)
}

export {AuthContext, AuthProvider};